import { c as _c } from "react/compiler-runtime";
import { stopLoggingBootErrors } from '@onefootprint/core';
import { Logger } from '@onefootprint/idv';
import type { AppProps } from 'next/app';
import Script from 'next/script';
import Providers from '../components/providers';
import { GOOGLE_MAPS_SRC } from '../config/constants';
import '../styles/globals.css';

// Don't enable logger replay until we know we are in a live onboarding
Logger.init('hosted', /* deferSessionRecord */true);
stopLoggingBootErrors();
const App = t0 => {
  const $ = _c(9);
  const {
    Component,
    pageProps
  } = t0;
  let t1;
  if ($[0] !== Component || $[1] !== pageProps) {
    t1 = <Component {...pageProps} />;
    $[0] = Component;
    $[1] = pageProps;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== pageProps || $[4] !== t1) {
    t2 = <Providers pageProps={pageProps}>{t1}</Providers>;
    $[3] = pageProps;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = GOOGLE_MAPS_SRC ? <Script src={GOOGLE_MAPS_SRC} strategy="lazyOnload" /> : null;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2) {
    t4 = <>{t2}{t3}</>;
    $[7] = t2;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};
export default App;